import ProductTilesWrapper from "../ProductTilesWrapper";
import LoadedItemsWrapper from "../LoadedItemsWrapper";
import PropTypes from "prop-types";
import isDiscountLabelEnabled from "./isDiscountLabelEnabled";

const LoadedItems = ({
  ItemsHeader,
  ProductTiles,
  ProductTile,
  NotificationsOptInBanner
}) => {
  const showDiscountLabel = isDiscountLabelEnabled();

  return (
    <LoadedItemsWrapper>
      {NotificationsOptInBanner ? <NotificationsOptInBanner /> : null}
      <ItemsHeader />
      <ProductTilesWrapper>
        <ProductTiles
          ProductTile={ProductTile}
          showDiscountLabel={showDiscountLabel}
        />
      </ProductTilesWrapper>
    </LoadedItemsWrapper>
  );
};

LoadedItems.propTypes = {
  ItemsHeader: PropTypes.elementType.isRequired,
  ProductTiles: PropTypes.elementType.isRequired,
  ProductTile: PropTypes.elementType.isRequired,
  NotificationsOptInBanner: PropTypes.elementType
};

export default LoadedItems;
